import Link from 'gatsby-link';
import React from 'react';
import styled from '@emotion/styled'
import ReactMarkdown from 'react-markdown';
import OnVisible from 'react-on-visible';
import breaks from 'remark-breaks';

function LinkRenderer(props) {
    if (props.href.indexOf('://') > -1) {
        return (
            <a href={props.href} target="_blank">
                {props.children}
            </a>
        );
    } else {
        return <a href={props.href}>{props.children}</a>;
    }
}
const MarkdownImage = props => {
    let altTag = '';
    if (props.alt != '') {
        altTag = <ImageCaption>{props.alt}</ImageCaption>;
    }
    return (
        <ImageWrapper fit={props.src.indexOf('#fit') > -1}>
            <img {...props} />
            {altTag}
        </ImageWrapper>
    );
};

const MarkdownComponent = ({ source, jobs, className }) => (
    <SlideOnVisible percent={30} className={className}>
        <ReactMarkdown
            source={source}
            containerTagName="div"
            plugins={[breaks]}
            className='markdown'
            renderers={{
                root: 'div',
                image: MarkdownImage,
                inlineCode: node => {
                    if (node.value == 'joblistdk') {
                        return JobList({
                            jobs: getJobs(jobs, 'dk'),
                        });
                    }
                    if (node.value == 'joblistjp') {
                        return JobList({
                            jobs: getJobs(jobs, 'jp'),
                        });
                    }

                    return '';
                },
                link: LinkRenderer,
            }}
        />
    </SlideOnVisible>
);


const ImageWrapper = styled.div`
    margin: ${props => (props.fit ? '40px 0' : '40px -100px')};
    img {
        max-width: 100%;
    }
    img[src*='#fig'] {
        max-width: 110%;
    }
`;
const ImageCaption = styled.div`
    width: 100%;
    font-size: 14px;
    color: gray;
    text-align: center;
    margin-bottom: 80px;
    display: block;
`;

const SlideOnVisible = styled(OnVisible)`

    .markdown{
      & > *{
        opacity: 0;
        transform: translateY(40px);
      }
      *:last-child{
        margin-bottom: 0;
      }
    }
    &.visible {

        .markdown{
          & > *{
            transition: all 0.5s;
            opacity: 1;
            transform: translateY(0px);
          }

          & > *:nth-child(1){
            transition-delay: .1s;
          }
          & > *:nth-child(2){
            transition-delay: .2s;
          }
          & > *:nth-child(3){
            transition-delay: .3s;
          }
          & > *:nth-child(4){
            transition-delay: .4s;
          }
          & > *:nth-child(5){
            transition-delay: .5s;
          }
          & > *:nth-child(6){
            transition-delay: .6s;
          }
          & > *:nth-child(7){
            transition-delay: .7s;
          }
          & > *:nth-child(8){
            transition-delay: .8s;
          }
        }
    }
`;

const JobList = ({ jobs }) => (
    <Div>
        {jobs &&
            jobs.map(job => (
                <Div key={job.node.id}>
                    <Link to={`/careers/${job.node.slug}`}>
                        {job.node.title}
                    </Link>
                </Div>
            ))}
    </Div>
);

const Div = styled.span`
    display: block;
`;

const getJobs = (jobs, locationcode) => {
    return (
        jobs &&
        jobs.edges.filter(itm => {
            return (
                itm.node.location.filter(loc => loc.code == locationcode)
                    .length > 0
            );
        })
    );
};

export default MarkdownComponent;
